export default {
    name: "en_US",
    messages: {
        _default: function (field) {
            return "Invalid"
        },
        after: function (field, args) {
            return "Accept dates after " + args[0]
        },
        alpha: function (field) {
            return "Accept alphabets only"
        },
        alpha_dash: function (field) {
            return "Accept alphabets, numbers, hyphens and underscores"
        },
        alpha_num: function (field) {
            return "Accept alphanumeric characters only"
        },
        alpha_spaces: function (field) {
            return "Accept alphabets and spaces"
        },
        before: function (field, args) {
            return "Accept dates before " + args[0]
        },
        between: function (field, args) {
            return "Accept number between " + args[0] + " and " + args[1] + " "
        },
        confirmed: function (field, args) {
            return "Passwords do not match"
        },
        credit_card: function (field) {
            return "Invalid card number"
        },
        date_between: function (field, args) {
            return "Accept dates between " + args[0] + " and " + args[1] + " "
        },
        date_format: function (field, args) {
            return "Accept dates with format " + args[0] + " "
        },
        decimal: function (field, args) {
            void 0 === args && (args = []);
            var t = args[0];
            return void 0 === t && (t = "*"), "Accept real numbers with exactly " + ("*" === t ? "" : t) + " decimal places"
        },
        digits: function (field, args) {
            return "Accept numbers with exactly" + args[0] + " digits"
        },
        dimensions: function (field, args) {
            return "Your image should be " + args[0] + "*" + args[1]
        },
        email: function (field) {
            return "Invalid email address"
        },
        emails: function (field) {
            return "Invalid email address"
        },
        excluded: function (field) {
            return "Invalid"
        },
        ext: function (field) {
            return "Invalid file type"
        },
        image: function (field) {
            return "Accept image files only"
        },
        included: function (field) {
            return "Invalid"
        },
        integer: function (field) {
            return "Accept integers only"
        },
        ip: function (field) {
            return "Invalid IP address"
        },
        length: function (field, args) {
            var t = args[0],
                r = args[1];
            return r ? "Accept strings with length between " + t + "characters to " + r + " characters" : "Should be exactly " + t + " characters"
        },
        max: function (field, args) {
            return "Maximum number of characters: " + args[0] + " "
        },
        max_value: function (field, args) {
            return "Should be less than or equal to " + args[0]
        },
        mimes: function (field) {
            return "Invalid file type"
        },
        min: function (field, args) {
            return "Minimum number of characters: " + args[0] + " "
        },
        min_value: function (field, args) {
            return "Should be greater than or equal to " + args[0]
        },
        numeric: function (field) {
            return "Accept numbers only"
        },
        regex: function (field) {
            return "Invalid format"
        },
        required: function (field) {
            return "Required"
        },
        size: function (field, args) {
            var t, r, u, i = args[0];
            return "The file size can not exceed " + (t = i, r = 1024, u = 0 == (t = Number(t) * r) ? 0 : Math.floor(Math.log(t) / Math.log(r)), 1 * (t / Math.pow(r, u)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][u]) + "."
        },
        url: function (field) {
            return "Invalid url"
        },
        multiple_of: function (field, args) {
            return "Should be a multiple of "+ args
        },
    }
}
